import { createAction } from '@reduxjs/toolkit'
import { GridSortModel } from '@mui/x-data-grid'

import type { Meta, Participant, Sort } from 'types/Participants'

export const setLoading = createAction<boolean>('participants/setLoading')

export const setParticipants = createAction(
  'participants/setParticipants',
  function prepare(participants: Participant[], meta: Meta) {
    return {
      payload: {
        participants,
        meta,
      },
    }
  },
)

export const setSort = createAction(
  'participants/setSort',
  function prepare(sort: Sort, model: GridSortModel) {
    return {
      payload: {
        sort,
        model,
      },
    }
  },
)

export const updateSelection = createAction(
  'participants/updateSelection',
  function prepare(participantIDs: string[]) {
    return {
      payload: {
        participantIDs,
      },
    }
  },
)

export const setPage = createAction<number>('participants/setPage')

export const setPerPage = createAction<number>('participants/setPerPage')

export const searchByNameOrEmail = createAction<string>(
  'participants/searchByNameOrEmail',
)

export const updateParticipant = createAction(
  'participant/updateParticipant',
  (participant: Participant) => {
    return {
      payload: {
        participant,
      },
    }
  },
)

export const setGridLoaderStatus = createAction<boolean>(
  'participants/setGridLoaderStatus',
)
